import src from "IMAGE";
export default { src, width: 13, height: 26, blurWidth: 0, blurHeight: 0};
